export const SITE_NAME = 'One Form';
export const SITE_TAGLINE = 'One form. Every workflow.';

// URL pública do logotipo (horizontal)
export const LOGO_URL = "/one-form-logo/SVG/logo-one-form.svg";

// URL do ícone (favicon / sidebar colapsada)
export const ICON_URL = "/one-form-logo/SVG/favicon-one-form.svg";
